var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { InfoCircledIcon, ListBulletIcon } from "@radix-ui/react-icons";
import client from "../../http/client";
import { formatCurrency } from "../utility/formatCurrency";
import { RadixAccordion, RadixAccordionContent, RadixAccordionItem, } from "../primitives/RadixAccordion";
import "../ui.css";
import "../orderSummary/orderSummary.css";
import "./orderTracker.css";
import { RadixButton } from "../primitives/RadixButton";
import { RadixModal } from "../primitives/RadixModal";
import { StateInitializationLoading } from "../stateInitializationLoading";
import { formatter } from "../utility/formatter";
import { clearPendingDealCode } from "../dealsSelection";
var POLL_INTERVAL_MS = 30000;
var toNumber = function (value) {
    if (value === null || value === undefined || value === "") {
        return 0;
    }
    var numericValue = typeof value === "string" ? Number(value) : value;
    return Number.isNaN(numericValue) ? 0 : numericValue;
};
var toDateLabel = function (value) {
    if (!value) {
        return "";
    }
    var parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) {
        return "";
    }
    return parsedDate.toLocaleString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
};
var toApproximateReadyTimeLabel = function (createdAt, currentTime) {
    if (!createdAt || currentTime === null || currentTime === undefined || currentTime === "") {
        return "";
    }
    var parsedCreatedAt = new Date(createdAt);
    if (Number.isNaN(parsedCreatedAt.getTime())) {
        return "";
    }
    var currentTimeValue = String(currentTime).trim();
    var minuteMatches = currentTimeValue.match(/\d+/g);
    if (!minuteMatches || minuteMatches.length === 0) {
        return "";
    }
    var minuteValues = minuteMatches
        .map(function (minuteValue) { return Number(minuteValue); })
        .filter(function (minuteValue) { return Number.isFinite(minuteValue) && minuteValue >= 0; });
    if (minuteValues.length === 0) {
        return "";
    }
    var readyDateLabels = minuteValues.slice(0, 2).map(function (minutes) {
        var readyDate = new Date(parsedCreatedAt.getTime() + minutes * 60000);
        return readyDate.toLocaleTimeString(undefined, {
            hour: "numeric",
            minute: "2-digit",
        });
    });
    if (readyDateLabels.length === 1) {
        return readyDateLabels[0];
    }
    return "".concat(readyDateLabels[0], " - ").concat(readyDateLabels[1]);
};
var toDiscountLines = function (value) {
    var discountList = [];
    if (Array.isArray(value)) {
        discountList = value;
    }
    else if (typeof value === "string") {
        try {
            var parsedDiscounts = JSON.parse(value);
            if (Array.isArray(parsedDiscounts)) {
                discountList = parsedDiscounts;
            }
        }
        catch (_error) {
            discountList = [];
        }
    }
    return discountList
        .map(function (entry) {
        if (!entry || typeof entry !== "object") {
            return null;
        }
        var discountEntry = entry;
        var rawCode = typeof discountEntry.code === "string" ? discountEntry.code.trim() : "";
        var amount = toNumber(discountEntry.amount);
        if (!rawCode || amount <= 0) {
            return null;
        }
        return {
            code: rawCode,
            amount: amount,
        };
    })
        .filter(function (line) { return Boolean(line); });
};
var getServiceTypeLabel = function (serviceType) {
    var serviceTypeName = typeof (serviceType === null || serviceType === void 0 ? void 0 : serviceType.name) === "string" ? serviceType.name.trim() : "";
    if (serviceTypeName) {
        return formatter.toProperCase(serviceTypeName);
    }
    var serviceTypePosId = toNumber(serviceType === null || serviceType === void 0 ? void 0 : serviceType.pos_id);
    if (serviceTypePosId === 1) {
        return "Delivery";
    }
    if (serviceTypePosId === 3) {
        return "Pickup";
    }
    return "Selected service";
};
var isCateringOrder = function (value) {
    return value === true || value === 1 || value === "1" || value === "true";
};
var getStatusLabel = function (status) {
    if (!status) {
        return "Processing";
    }
    if (status === "POS_DeliveryReady") {
        return "Delivery ready";
    }
    if (status === "POS_OtherReady") {
        return "Order ready";
    }
    if (status === "POS_Complete") {
        return "Order received";
    }
    return "Order submitted";
};
var getLineComment = function (comment) {
    return typeof comment === "string" ? comment.trim() : "";
};
var getItemModifiers = function (modifiers) {
    if (!Array.isArray(modifiers)) {
        return [];
    }
    return modifiers.filter(function (modifier) {
        if (!modifier || typeof modifier !== "object") {
            return false;
        }
        var quantity = typeof modifier.quantity === "number" ? modifier.quantity : 0;
        var hasName = Boolean(String(modifier.name || "").trim());
        return quantity > 0 && hasName;
    });
};
var getModifiersByPortion = function (modifiers, portions) {
    return getItemModifiers(modifiers).filter(function (modifier) {
        return Boolean(modifier.portion && portions.includes(modifier.portion));
    });
};
var formatModifier = function (modifier) {
    var baseName = String(modifier.name || "Modifier");
    var quantity = typeof modifier.quantity === "number" ? modifier.quantity : 0;
    if (quantity <= 1) {
        return formatter.removeTrailingAsterisk(baseName);
    }
    return "".concat(formatter.removeTrailingAsterisk(baseName), " x").concat(quantity);
};
var formatModifiers = function (modifiers) {
    return modifiers.map(function (modifier) { return formatModifier(modifier); }).join(", ");
};
var parseOrderData = function (value) {
    if (!value) {
        return null;
    }
    if (typeof value === "string") {
        try {
            var parsed = JSON.parse(value);
            return parseOrderData(parsed);
        }
        catch (_error) {
            return null;
        }
    }
    if (typeof value !== "object") {
        return null;
    }
    return value;
};
var getNextOrder = function (responseData) {
    if (!responseData || typeof responseData !== "object") {
        return null;
    }
    var record = responseData;
    var nestedOrder = parseOrderData(record.order);
    if (nestedOrder) {
        return nestedOrder;
    }
    var orderData = parseOrderData(record.order_data);
    if (orderData) {
        return orderData;
    }
    return parseOrderData(responseData);
};
export var OrderTracker = function () {
    var _a, _b, _c, _d;
    var _e = useState(function () {
        var _a;
        return ((_a = window.order) !== null && _a !== void 0 ? _a : {});
    }), order = _e[0], setOrder = _e[1];
    var _f = useState(null), pollingError = _f[0], setPollingError = _f[1];
    var _g = useState(function () { return new Date().toISOString(); }), lastUpdatedAt = _g[0], setLastUpdatedAt = _g[1];
    var _h = useState(true), isOrderDetailsExpanded = _h[0], setIsOrderDetailsExpanded = _h[1];
    var _j = useState(false), showTaxAndFeesModal = _j[0], setShowTaxAndFeesModal = _j[1];
    var _k = useState(function () { return Boolean(order === null || order === void 0 ? void 0 : order.reference); }), isInitialLoading = _k[0], setIsInitialLoading = _k[1];
    var orderReference = order === null || order === void 0 ? void 0 : order.reference;
    var processorApprovalCode = typeof order.cc_auth_code === "string" ? order.cc_auth_code.trim() : "";
    var status = typeof (order === null || order === void 0 ? void 0 : order.status) === "string" ? order.status : "";
    var serviceTypePosId = toNumber((_a = order === null || order === void 0 ? void 0 : order.service_type) === null || _a === void 0 ? void 0 : _a.pos_id);
    var isDeliveryServiceType = serviceTypePosId === 1;
    var isDeliveryReady = status === "POS_DeliveryReady";
    var isOtherReady = status === "POS_OtherReady";
    var hasReadyStep = isDeliveryReady || isOtherReady;
    var isPosComplete = status === "POS_Complete" || hasReadyStep;
    var deferredOrderTimeLabel = toDateLabel(order.deferred_datetime);
    var approximateReadyTimeLabel = toApproximateReadyTimeLabel(order.created_at, (_b = order.service_type) === null || _b === void 0 ? void 0 : _b.current_time);
    var serviceTypeLabel = getServiceTypeLabel(order.service_type);
    var orderModeLabel = isCateringOrder(order.is_catering_order) ? "Catering" : "Online";
    var configuredNcaTitle = (_d = (_c = window.session) === null || _c === void 0 ? void 0 : _c.store) === null || _d === void 0 ? void 0 : _d.nca_title;
    var ncaFeeTitle = typeof configuredNcaTitle === "string" && configuredNcaTitle.trim().length > 0
        ? formatter.toProperCase(configuredNcaTitle)
        : "Technology Fee";
    useEffect(function () {
        clearPendingDealCode();
    }, []);
    useEffect(function () {
        if (!orderReference) {
            return;
        }
        var isMounted = true;
        var interval;
        setIsInitialLoading(true);
        var pollOrderStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, nextOrder, _error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, client.post("/order/status", {
                                reference: orderReference,
                            })];
                    case 1:
                        response = _a.sent();
                        nextOrder = getNextOrder(response.data);
                        if (!isMounted || !nextOrder) {
                            return [2 /*return*/];
                        }
                        setOrder(nextOrder);
                        setLastUpdatedAt(new Date().toISOString());
                        setPollingError(null);
                        setIsInitialLoading(false);
                        // Stop polling once POS completes
                        if (nextOrder.status === "POS_Complete" && interval) {
                            window.clearInterval(interval);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        _error_1 = _a.sent();
                        if (!isMounted) {
                            return [2 /*return*/];
                        }
                        setPollingError("We couldn't refresh your order just now. We'll keep trying automatically.");
                        setIsInitialLoading(false);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        // Run immediately on mount / orderReference change
        pollOrderStatus();
        interval = window.setInterval(function () {
            pollOrderStatus();
        }, POLL_INTERVAL_MS);
        return function () {
            isMounted = false;
            if (interval) {
                window.clearInterval(interval);
            }
        };
    }, [orderReference]);
    var steps = useMemo(function () {
        return __spreadArray([
            {
                key: "submitted",
                label: "Order submitted",
                description: "Your order was placed successfully.",
                complete: true,
                current: !isPosComplete,
            },
            {
                key: "received",
                label: "Order received",
                description: isPosComplete
                    ? "The store has received your order."
                    : "Waiting for the store POS to receive your order!",
                complete: isPosComplete || hasReadyStep,
                current: isPosComplete && !hasReadyStep,
            }
        ], (hasReadyStep
            ? [{
                    key: "ready",
                    label: isDeliveryServiceType ? "Delivery ready" : "Order ready",
                    description: isDeliveryServiceType
                        ? "Your order is out for delivery!"
                        : "Your order is ready for you!.",
                    complete: true,
                    current: true,
                }]
            : []), true);
    }, [hasReadyStep, isDeliveryServiceType, isPosComplete]);
    var lines = Array.isArray(order.lines) ? order.lines : [];
    var itemCount = lines.reduce(function (sum, line) {
        return sum + (typeof line.quantity === "number" ? line.quantity : 0);
    }, 0);
    var taxBreakdownLines = useMemo(function () {
        if (!Array.isArray(order.taxes)) {
            return [{ label: "Tax", amount: toNumber(order.tax) }].filter(function (line) { return line.amount > 0; });
        }
        var parsedTaxes = order.taxes
            .map(function (entry) {
            var _a, _b, _c, _d;
            if (!entry || typeof entry !== "object") {
                return null;
            }
            var taxEntry = entry;
            var label = (_a = [taxEntry.name, taxEntry.title, taxEntry.label]
                .find(function (value) { return typeof value === "string" && value.trim().length > 0; })) !== null && _a !== void 0 ? _a : "Tax";
            var amount = toNumber((_d = (_c = (_b = taxEntry.amount) !== null && _b !== void 0 ? _b : taxEntry.value) !== null && _c !== void 0 ? _c : taxEntry.tax) !== null && _d !== void 0 ? _d : taxEntry.total);
            if (amount <= 0) {
                return null;
            }
            return {
                label: formatter.toProperCase(label),
                amount: amount,
            };
        })
            .filter(function (line) { return Boolean(line); });
        if (parsedTaxes.length === 0) {
            return [{ label: "Tax", amount: toNumber(order.tax) }].filter(function (line) { return line.amount > 0; });
        }
        return parsedTaxes;
    }, [order.tax, order.taxes]);
    var taxAndFeesBreakdown = useMemo(function () {
        var ncaFee = toNumber(order.nca_fee);
        var serviceFee = toNumber(order.service_fee);
        return __spreadArray(__spreadArray(__spreadArray([], taxBreakdownLines, true), (ncaFee > 0 ? [{ label: ncaFeeTitle, amount: ncaFee }] : []), true), (serviceFee > 0 ? [{ label: "Service Fee", amount: serviceFee }] : []), true);
    }, [ncaFeeTitle, order.nca_fee, order.service_fee, taxBreakdownLines]);
    var taxesAndFeesTotal = taxAndFeesBreakdown.reduce(function (sum, line) { return sum + line.amount; }, 0);
    var discounts = toDiscountLines(order.discounts);
    var totalSavings = discounts.reduce(function (sum, discount) { return sum + discount.amount; }, 0);
    var subtotal = toNumber(order.subtotal);
    var subtotalWithDiscountAddedIn = (Math.round(subtotal * 100) + Math.round(totalSavings * 100)) / 100;
    var tax = toNumber(order.tax);
    var deliveryFee = toNumber(order.delivery_fee);
    var deliveryTip = toNumber(order.delivery_tip);
    var ncaFee = toNumber(order.nca_fee);
    var serviceFee = toNumber(order.service_fee);
    var computedOrderTotal = subtotal + tax + deliveryFee + deliveryTip + ncaFee + serviceFee;
    var hasDeliveryFee = deliveryFee > 0;
    var hasDeliveryTip = deliveryTip > 0;
    if (isInitialLoading) {
        return (React.createElement(StateInitializationLoading, { label: "Submitting your order, please wait", wrapperClassName: "radix-order-tracker-page", mainClassName: "radix-order-tracker", sectionClassName: "radix-order-tracker-panel", ariaLabel: "Submitting your order" }));
    }
    return (React.createElement("div", { className: "radix-order-tracker-page" },
        React.createElement("main", { className: "radix-order-tracker", "aria-labelledby": "order-tracker-heading" },
            React.createElement("header", { className: "radix-order-tracker-header" },
                React.createElement("h1", { id: "order-tracker-heading", className: "radix-order-tracker-title" }, "Order status"),
                React.createElement("p", { className: "radix-order-tracker-subtitle" },
                    "You're all set! Your ",
                    orderModeLabel.toLowerCase(),
                    " order is confirmed for ",
                    serviceTypeLabel.toLowerCase(),
                    "."),
                React.createElement("dl", { className: "radix-order-tracker-meta", "aria-label": "Order details" },
                    React.createElement("div", null,
                        React.createElement("dt", null, "Status"),
                        React.createElement("dd", null, getStatusLabel(status))),
                    React.createElement("div", null,
                        React.createElement("dt", null, "Order Type"),
                        React.createElement("dd", null, orderModeLabel)),
                    React.createElement("div", null,
                        React.createElement("dt", null, "Service Type"),
                        React.createElement("dd", null, serviceTypeLabel)),
                    React.createElement("div", null,
                        React.createElement("dt", null, "Reference"),
                        React.createElement("dd", null, order.reference || "—")),
                    processorApprovalCode ? (React.createElement("div", null,
                        React.createElement("dt", null, "Processor approval code"),
                        React.createElement("dd", null, processorApprovalCode))) : null,
                    toDateLabel(order.created_at) ? (React.createElement("div", null,
                        React.createElement("dt", null, "Placed"),
                        React.createElement("dd", null, toDateLabel(order.created_at)))) : null,
                    deferredOrderTimeLabel ? (React.createElement("div", null,
                        React.createElement("dt", null, "Scheduled"),
                        React.createElement("dd", null, deferredOrderTimeLabel))) : approximateReadyTimeLabel ? (React.createElement("div", null,
                        React.createElement("dt", null, "Approximate Ready Time"),
                        React.createElement("dd", null, approximateReadyTimeLabel))) : null),
                React.createElement("p", { className: "radix-order-tracker-last-updated", "aria-live": "polite" },
                    "Last updated: ",
                    toDateLabel(lastUpdatedAt) || "just now")),
            React.createElement("section", { className: "radix-order-tracker-panel", "aria-labelledby": "order-tracker-progress-title" },
                React.createElement("h2", { id: "order-tracker-progress-title", className: "radix-order-tracker-panel-title" }, "Progress"),
                React.createElement("ol", { className: "radix-order-tracker-steps", "aria-live": "polite" }, steps.map(function (step) { return (React.createElement("li", { key: step.key, className: [
                        "radix-order-tracker-step",
                        step.complete ? "is-complete" : "",
                        step.current ? "is-current" : "",
                    ].join(" ").trim() },
                    React.createElement("span", { className: "radix-order-tracker-step-marker", "aria-hidden": "true" }),
                    React.createElement("div", { className: "radix-order-tracker-step-content" },
                        React.createElement("p", { className: "radix-order-tracker-step-label" }, step.label),
                        React.createElement("p", { className: "radix-order-tracker-step-description" }, step.description)))); })),
                pollingError ? (React.createElement("p", { className: "radix-order-tracker-polling-error", role: "status" }, pollingError)) : null),
            React.createElement("section", { className: "radix-order-tracker-panel", "aria-labelledby": "order-tracker-summary-title" },
                React.createElement("div", { className: "radix-order-tracker-section-heading" },
                    React.createElement("span", { className: "section-icon", "aria-hidden": "true" },
                        React.createElement(ListBulletIcon, null)),
                    React.createElement("h2", { id: "order-tracker-summary-title", className: "radix-order-tracker-panel-title" },
                        "Order details (",
                        itemCount,
                        " item",
                        itemCount === 1 ? "" : "s",
                        ")")),
                lines.length > 0 ? (React.createElement(RadixAccordion, { type: "single", className: "radix-order-tracker-details-accordion", value: isOrderDetailsExpanded ? "details" : "", onValueChange: function (value) { return setIsOrderDetailsExpanded(value === "details"); } },
                    React.createElement(RadixAccordionItem, { value: "details", className: "radix-order-tracker-details-item" },
                        React.createElement(RadixAccordionContent, { className: "radix-order-tracker-details-content" },
                            React.createElement("div", { className: "radix-order-tracker-details-inner" },
                                React.createElement("ul", { className: "radix-order-tracker-line-list", "aria-label": "Order item details" }, lines.map(function (line, index) {
                                    var _a;
                                    var name = String(line.friendly_name || line.name || "Menu item");
                                    var quantity = typeof line.quantity === "number" ? line.quantity : 0;
                                    var lineTotal = toNumber((_a = (line.subtotal * line.quantity)) !== null && _a !== void 0 ? _a : 0);
                                    var wholeMods = getModifiersByPortion(line.modifications, ["whole"]);
                                    var firstHalfMods = getModifiersByPortion(line.modifications, ["first-half"]);
                                    var secondHalfMods = getModifiersByPortion(line.modifications, ["second-half"]);
                                    var unportionedMods = getItemModifiers(line.modifications).filter(function (modifier) { return !modifier.portion; });
                                    var lineComment = getLineComment(line.comment);
                                    var key = line.id || "".concat(name, "-").concat(index);
                                    return (React.createElement("li", { key: key, className: "radix-order-tracker-line-item" },
                                        React.createElement("div", null,
                                            React.createElement("p", { className: "radix-order-tracker-line-name" }, name),
                                            React.createElement("p", { className: "radix-order-tracker-line-meta" },
                                                "Qty: ",
                                                quantity),
                                            (wholeMods.length > 0 || firstHalfMods.length > 0 || secondHalfMods.length > 0 || unportionedMods.length > 0) ? (React.createElement("div", { className: "radix-order-tracker-modifiers", "aria-label": "".concat(name, " modifiers") },
                                                wholeMods.length > 0 ? (React.createElement("p", { className: "radix-order-tracker-line-meta" },
                                                    React.createElement("strong", null, "Whole:"),
                                                    " ",
                                                    formatModifiers(wholeMods))) : null,
                                                firstHalfMods.length > 0 ? (React.createElement("p", { className: "radix-order-tracker-line-meta" },
                                                    React.createElement("strong", null, "First Half:"),
                                                    " ",
                                                    formatModifiers(firstHalfMods))) : null,
                                                secondHalfMods.length > 0 ? (React.createElement("p", { className: "radix-order-tracker-line-meta" },
                                                    React.createElement("strong", null, "Second Half:"),
                                                    " ",
                                                    formatModifiers(secondHalfMods))) : null,
                                                unportionedMods.length > 0 ? (React.createElement("p", { className: "radix-order-tracker-line-meta" }, formatModifiers(unportionedMods))) : null)) : null,
                                            lineComment ? React.createElement("p", { className: "radix-order-tracker-line-comment" },
                                                React.createElement("strong", null, "Note:"),
                                                " ",
                                                lineComment) : null),
                                        React.createElement("p", { className: "radix-order-tracker-line-total" }, formatCurrency(lineTotal))));
                                })),
                                React.createElement("section", { className: "radix-order-summary" },
                                    React.createElement("dl", { className: "radix-order-summary-list" },
                                        React.createElement("div", { className: "radix-order-summary-row" },
                                            React.createElement("dt", null, "Subtotal"),
                                            React.createElement("dd", null, formatCurrency(subtotalWithDiscountAddedIn))),
                                        totalSavings > 0 ? (React.createElement("div", { className: "radix-order-summary-row radix-order-summary-discount" },
                                            React.createElement("dt", null, "Discount"),
                                            React.createElement("dd", null,
                                                "-",
                                                formatCurrency(totalSavings)))) : null,
                                        hasDeliveryFee ? (React.createElement("div", { className: "radix-order-summary-row" },
                                            React.createElement("dt", null, "Delivery"),
                                            React.createElement("dd", null, formatCurrency(deliveryFee)))) : null,
                                        taxAndFeesBreakdown.length > 0 ? (React.createElement("div", { className: "radix-order-summary-row" },
                                            React.createElement("dt", null,
                                                React.createElement("button", { type: "button", className: "radix-order-summary-label-with-action", "aria-label": "View taxes and other fees breakdown", onClick: function () { return setShowTaxAndFeesModal(true); } },
                                                    React.createElement("span", null, "Tax and other fees"),
                                                    React.createElement(InfoCircledIcon, { "aria-hidden": "true", className: "radix-order-summary-info-icon" }))),
                                            React.createElement("dd", null, formatCurrency(taxesAndFeesTotal)))) : null,
                                        hasDeliveryTip ? (React.createElement("div", { className: "radix-order-summary-row" },
                                            React.createElement("dt", null, "Gratuity"),
                                            React.createElement("dd", null, formatCurrency(deliveryTip)))) : null,
                                        React.createElement("div", { className: "radix-order-summary-row radix-order-summary-total" },
                                            React.createElement("dt", null, "Total"),
                                            React.createElement("dd", null, formatCurrency(computedOrderTotal)))))))))) : null,
                React.createElement(RadixModal, { open: showTaxAndFeesModal, onOpenChange: setShowTaxAndFeesModal, title: "Tax and other fees", description: "Here is the full breakdown of all taxes and fees applied to your order." },
                    React.createElement("dl", { className: "radix-order-summary-breakdown-list" }, taxAndFeesBreakdown.map(function (line) { return (React.createElement("div", { className: "radix-order-summary-row", key: "".concat(line.label, "-").concat(line.amount) },
                        React.createElement("dt", null, line.label),
                        React.createElement("dd", null, formatCurrency(line.amount)))); })))),
            React.createElement(RadixButton, { onClick: function () { window.location.assign("".concat(window.relativeURI(), "/menu")); }, className: "radix-submit-button radix-order-tracker-cta" }, "Place another order"))));
};
